import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"
import styled from "styled-components"

import TotalWeightValidation from "./TotalWeightValidation"

const CustomsValidation = props => {
  const {} = props

  return (
    <>
      <TotalWeightValidation />
    </>
  )
}

export default CustomsValidation
